import { useState } from "react";

/**
 * Hook useState assincrono
 * @param initialState
 * @returns [state, setState, getState]
 */

export function useSetState<State = any>(initialState: State | (() => State)) {
	const [state, setState] = useState<State>(initialState);

	const getState = async (): Promise<State> => {
		let asyncState: unknown;

		await setState((currentState: State) => {
			asyncState = currentState;

			return currentState;
		});

		return asyncState as State;
	};

	return [state, setState, getState] as [
		State,
		typeof setState,
		typeof getState,
	];
}
